import React from 'react'
import Image from 'next/image'
import { INPUT_ICON, INPUT_ICON_LOGO } from '@components/MainWidget/FastagWidget/constants'
import assetLoader from '@utils/internalImageLoader'
import { getClassNames } from '@helpers/productWidgetHelper'
import FlipCardComponent from './FlipCardComponent'
import styles from './CommonComponents.module.scss'

export const GovernmentVerifiedBatch = () => (
  <div className={styles.governmentVerifiedBatch}>
    <Image src="https://acko-cms.ackoassets.com/check_mark_052ddd7c91.svg" alt="check-sign" height={16} width={16} />
    <p>Government verified sources</p>
  </div>
)

export const NumberPlate = ({ regNum }: { regNum: string }) =>
  regNum ? (
    <div className={styles.numberPlate}>
      <Image
        width={0}
        height={0}
        src={`${assetLoader()}${INPUT_ICON}`}
        className={styles.inputIcon}
        alt={INPUT_ICON_LOGO}
      />
      <p>{regNum}</p>
    </div>
  ) : null

export const FlipCard = ({
  lightBackground,
  data = [],
}: {
  lightBackground?: boolean
  data?: Array<{ image: string; text: string }>
}) => (
  <div className={getClassNames([styles.flipCardBackground], { [styles.lightBackground]: !!lightBackground })}>
    <div className={styles.flipCardContainer}>
      <FlipCardComponent
        items={data.map(d => (
          <Image src={d.image} alt="profiles" height={32} width={93} />
        ))}
      />
      <FlipCardComponent
        items={data.map(d => (
          <p>{d.text}</p>
        ))}
      />
    </div>
  </div>
)
